export default __webpack_public_path__ + "static/media/27.f28fe433.png";